<template>
  <div>
    <NavBar></NavBar>
    <div class="container">
      <div class="row">
        <template v-if="errored">
          <b-alert variant="danger" show>
            Sorry. System we're not able to retieve this information
          </b-alert>
        </template>
        <template v-else>
          <template v-if="loading">
            <b-icon icon="three-dots" animation="cylon" font-scale="4"></b-icon>
          </template>
          <template v-else>
            <ClientCard
              v-for="client in info"
              :key="client.org_id"
              :orgName="client.org_name"
              class="col-md-6"
              :state="client.org_state"
              :endday="client.org_updated_on | justdate"
              :orgEmail="client.org_email"
              :orgTel="client.org_tel"
              :orgAddLn1="client.org_add_ln1"
              :orgAddLn2="client.org_add_ln2"
              :orgAddStreet="client.org_add_street"
              :orgAddCity="client.org_add_city"
              :orgAddCounty="client.org_add_county"
              :orgAddPC="client.org_add_postcode"
              :perTitle="client.per_title"
              :perFname="client.per_first_name"
              :perLname="client.per_last_name"
              :perJob="client.per_job_role"
              :perEmail="client.per_email"
              :perTel="client.per_tel"
              :PerMob="client.per_mob"
              :orgAdded="client.org_created_on"
            ></ClientCard>
          </template>
        </template>
      </div>
    </div>
    <UserCheck></UserCheck>
    <Footer></Footer>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer.vue";
import ClientCard from "@/components/SubCompViewClient.vue";
import ServerLinks from "../config.js";
import axios from "axios";
import UserCheck from "@/components/CompUserCheck.vue";

export default {
  name: "ViewClients",
  components: {
    NavBar,
    ClientCard,
    UserCheck,
    Footer
  },
  data() {
    return {
      info: null,
      loading: true,
      errored: false
    };
  },
  mounted() {
    //console.log(Package);
    let fdvc = new FormData();
    fdvc.append("getclients", "getclients");
    axios
      //.get(ServerLinks.CONTROLLER)
      .post(ServerLinks.SERVERCTRL, fdvc)
      .then(response => {
        let dt = response.data;
        //console.log(dt);
        this.info = dt;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => (this.loading = false));
  }
};
</script>
